import React,{useState,useRef,useEffect} from 'react'
import _ from 'lodash'
import { useParams } from 'react-router-dom'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment, Search, DropdownMenu, DropdownDivider, DropdownHeader, DropdownItem } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../services/redirect'
import Paginations from '../../services/paginations'
import EntryList from '../../services/entries'
import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import AlertConfirmation from '../../services/confirmation'

import AuthDenied from '../ErrorPage/denied'

export default function DeletedHistoryNotesComponent(props){

  const params = useParams();


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='confirm'){
    }
  }


  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }

 
  function handleSubmitForm(values, props){
    if(buttonclick==1){
      props.resetForm();
      TableList(pagenumber,search);
    }else{
      let value={
        notes_id:values.notes_id,
        product:values.product,
        account:values.account,
        note:values.note
      }
      TableList(pagenumber,value);
    }
  }
   
  const [notesAccountId, setNotesAccountId] = useState('');
  const [search, setsearch]  = useState({
      notes_id:params.id,
      product:'',
      account:'',
      note:''
	});
  const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	  function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','deleted_history');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/processing-notes/request.php',formData)
				.then(function (response) {
          
						let obj = response.data;

						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable.array_data);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
            setNotesAccountId(obj.listtable.account_id);
            setspinner(false);
				})
				.catch(function (error){
          setspinner(false);
				});
	}




  /*------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('yt2d71v4r8p36qfwe');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        // Load page when view permission is granted
        if(obj.view==1){
          if(params.id){
            TableList(pagenumber,search);
          }else{
            WindowLocation('/processing-notes/deleted_list');
            return false;
          }
        }
        setloader(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }


  useEffect(()=>{
    // Load Permission
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>



       {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
       {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

       {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
       {spinoverlay&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}


       {(authPages['view']==0&&!loader)&&<AuthDenied/>}
       {(authPages['view']==1&&!loader)&&<React.Fragment>


       <div className="app-page-title">
          <h1>Deleted History Processing Notes</h1>
          <p>From Notes ID: {notesAccountId}</p>
       </div>
       <div className="app-body-wrapper">

       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
        <Formik
            initialValues={search}
            onSubmit={handleSubmitForm}
            >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {


         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form>
                    <Form.Group widths="equal">
                      <Field name="account">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Account</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                      </Field>
                      <Field name="product">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Product</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                      </Field>
                      <Field name="note">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Note</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                      </Field>
                    </Form.Group>
                 </Form>
              </div>
              <div className="search-footer">
                  <Button type="button" icon='sync alternate' size='tiny' className="LightGrayButton" content='Reset' onClick={() => buttonSubmit(1)}/>
                  <Button type="button" icon='search' size='tiny' className="GreenButton" content='Search' onClick={() => buttonSubmit(2)}/>
                  <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
              </div>
           </div>
        </React.Fragment>
         )}}
         </Formik>





      {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {!spinner&&<React.Fragment>
      <div className="tableWrapper">
       <div className="panel-table">

         <div className="panel-table-header">
           <div>{entry>0&&<EntryList entrycallback={entry} entryType={entrytype} lengthCallback={totaldata} callbackreload={listreload}/>}</div>
           <div></div>
         </div>

         <div className="panel-table-body">
         <div className="table-responsive overflow">
           <Table celled compact='very'>
             <Table.Header>
               <Table.Row>
                 <Table.HeaderCell>Notes ID</Table.HeaderCell>
                 <Table.HeaderCell>Version</Table.HeaderCell>
                 <Table.HeaderCell>Account Number</Table.HeaderCell>
                 <Table.HeaderCell>Account Name</Table.HeaderCell>
                 <Table.HeaderCell>Product</Table.HeaderCell>
                 <Table.HeaderCell>Quantity</Table.HeaderCell>
                 <Table.HeaderCell>Price</Table.HeaderCell>
                 <Table.HeaderCell>Carriage</Table.HeaderCell>
                 <Table.HeaderCell>Handling Fee</Table.HeaderCell>
                 <Table.HeaderCell>Note</Table.HeaderCell>
                 <Table.HeaderCell>Date</Table.HeaderCell>
               </Table.Row>
             </Table.Header>

             <Table.Body>
                   {list.length==0&&<Table.Row negative><Table.Cell  colSpan='11' textAlign="center">No record found</Table.Cell></Table.Row>}
                   {list.map(function(data, key){
                     return <Table.Row key={key} verticalAlign='top' negative>
                          <Table.Cell>{data.notes_account}</Table.Cell>
                          <Table.Cell>{data.version_num}</Table.Cell>
                          <Table.Cell>{data.account_number}</Table.Cell>
                          <Table.Cell>{data.account_name}</Table.Cell>
                          <Table.Cell>
                            <div className="descriptionTable">
                              <div>
                                  <div style={{'opacity':'0.8'}}>{data.product_code}</div>
                                  <h3>{data.product_name}</h3>
                              </div>
                            </div>
                         </Table.Cell>
                         <Table.Cell>{data.quantity}</Table.Cell>
                         <Table.Cell>{data.price}</Table.Cell>
                         <Table.Cell>{data.carriage}</Table.Cell>
                         <Table.Cell>{data.handling_fee}</Table.Cell>
                         <Table.Cell>{data.note}</Table.Cell>
                         <Table.Cell collapsing>
                            <div className="descriptionTable">
                              <div>
                                  <h3>{data.date_added}</h3>
                                  <p>{data.date_time}</p>
                              </div>
                            </div>
                         </Table.Cell>
                     </Table.Row>
                   })}
               </Table.Body>
               {list.length>0&&
                 <Table.Footer fullWidth>
                     <Table.Row>
                     <Table.HeaderCell colSpan='11'>
                         <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                     </Table.HeaderCell>
                     </Table.Row>
                 </Table.Footer>
               }
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
        </div>

        </React.Fragment>}

       </div>{/*.app-body-wrapper*/}
       </React.Fragment>}
    </React.Fragment>
  )
}
